import React, { useState } from 'react';
import { Form, Select, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { EmissorNotaServices } from './services/movimentacoesService';
import { EmitenteProps } from './props';
import mask from '../../utils/mask';
import TitleFilter from '../TextFilter';
const SelectEmitente: React.FC<EmitenteProps> = ({ setEmitent }) => {

  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const [response, setResponse] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const emissorAll = localStorage.getItem(`emissorNota${window.location.pathname}`);
  const { Option } = Select;

  const getEmissorNota = () => {
    setLoading(true)
    EmissorNotaServices.getEmitentes(inscricaoAtiva, cddAtivo?.codCdd).then((res) => {
      setResponse(res?.data.emitentes);
      setLoading(false)
    });
  };

  const onChange = (value: any) => {
    setEmitent(value);
    localStorage.setItem(`emissorNota${window.location.pathname}`, value);
  };

  const children = [];
  children.push(
    response?.map((inscData: any) => (
      <Option
        title={inscData.nome}
        className="optionselect"
        value={inscData.nome}
        key={inscData.codParc}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjCpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nome} - Código: {inscData.codParc}
        <hr />
      </Option>
    ))
  );

  return (
    <Form.Item label={<TitleFilter>Emitente</TitleFilter>} name="emissorNota">
      <Select data-cy="emitente"
        showSearch
        style={{ width: '100%' }}
        onFocus={getEmissorNota}
        onChange={onChange}
        filterOption={(inputValue, element) =>
          element?.props.children
            .toString()

            .toLowerCase()
            .includes(inputValue.toLowerCase())
        }
        defaultValue={!emissorAll ? '' : emissorAll}
        loading={loading}
        notFoundContent={<Spin style={{textAlign:"center", width:"100%"}}/>}
      >
        {children}
      </Select>
    </Form.Item>
  );
};

export default SelectEmitente;
